import { getMomentTz } from "@dexteel/mesf-core";
import { ColDef, ColGroupDef } from "ag-grid-community";

const moment = getMomentTz();

export const useStatisticsColumns = () => {
  const columns: (ColDef | ColGroupDef)[] = [
    {
      field: "Date",
      headerName: "Date",
      filter: "agDateColumnFilter",
      valueFormatter: (params) => {
        if (!params.value) return "";
        return moment(params.value).format("YYYY-MM-DD");
      },
      flex: 1,
      minWidth: 120,
    },
    {
      headerName: "Heats",
      children: [
        {
          field: "HeatsInStock",
          headerName: "In Stock",
          filter: "agNumberColumnFilter",
          type: "numericColumn",
          flex: 1,
          minWidth: 100,
        },
        {
          field: "HeatsMoved",
          headerName: "Moved",
          filter: "agNumberColumnFilter",
          type: "numericColumn",
          flex: 1,
          minWidth: 100,
        },
        {
          field: "HeatsFragmentation",
          headerName: "Fragmented",
          filter: "agNumberColumnFilter",
          type: "numericColumn",
          flex: 1,
          minWidth: 120,
        },
      ],
    } as ColGroupDef,
    {
      headerName: "Billets",
      children: [
        {
          field: "BilletsStock",
          headerName: "Stock",
          filter: "agNumberColumnFilter",
          type: "numericColumn",
          flex: 1,
          minWidth: 100,
        },
        {
          field: "BilletsMoved",
          headerName: "Moved",
          filter: "agNumberColumnFilter",
          type: "numericColumn",
          flex: 1,
          minWidth: 100,
        },
        {
          field: "BilletsOlderCount",
          headerName: "Older",
          filter: "agNumberColumnFilter",
          type: "numericColumn",
          flex: 1,
          minWidth: 100,
        },
      ],
    } as ColGroupDef,
  ];

  return { columns };
};
